import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import importerStyles from "./ImporterPage.module.scss";

interface Props {
    icon: React.ReactNode;
    message: string;
    onlyIcon?: boolean;
    className?: string;
}

export const ImporterDocumentStatusMessage: React.FC<Props> = ({
    icon,
    message,
    onlyIcon,
    className,
}) => {
    if (onlyIcon) {
        return (
            <Tooltip content={message}>
                <div
                    className={classNames(
                        importerStyles.statusMessage,
                        className,
                    )}
                >
                    {icon}
                </div>
            </Tooltip>
        );
    }

    return (
        <div className={classNames(importerStyles.statusMessage, className)}>
            {icon}
            <span>{message}</span>
        </div>
    );
};
